import React, {memo} from "react";
import { useTheme } from "@material-ui/core/styles";
import { InputLabel } from "@material-ui/core";

const Text = (props) => {
  const theme = useTheme();
  const {id, label, style, value, className, textProps={}, width=100, fullWidth} = props;

  const baseStyle = {
    width,
    padding: "0px 10px",
  };
  if (fullWidth) {
    baseStyle.width = "100%";
  }

  const textBaseStyle={
    marginTop: 8,
    color: theme.palette.secondary.main,
    ...theme.typography.body1,
    position: "relative",
    top: -2,
    width: "100%",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
  }

  const textPropsBase = {
    ...textProps,
    style: {...textBaseStyle, ...textProps.style}
  }

  return (
    <div className={className} style={{...baseStyle, ...style}} id={`${id}`}>
      {label?
        <InputLabel shrink id={`${id}-label`} style={{position: "relative"}} >{label}</InputLabel>
        :<></>
      }
      <div id={`${id}-text`} {...textPropsBase}>{value || "\u00a0"}</div>
    </div>
  );
}

export default memo(Text);
